import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import {
  deleteAdminSponsoredCampaign,
  getAdminSponsoredCampaigns,
} from "../../utils/adminApi";

function AdminSponsoredCampaignsSection() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getAdminSponsoredCampaigns();
      setCampaigns(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setError(err.message || "Неуспешно вчитување на sponsored campaigns.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCampaigns();
  }, []);

  const onDelete = async (postId) => {
    if (!window.confirm("Сигурни сте дека сакате да ја избришете кампањата?")) {
      return;
    }
    try {
      setError("");
      setSuccess("");
      await deleteAdminSponsoredCampaign(postId);
      setSuccess("Кампањата е избришана.");
      await loadCampaigns();
    } catch (err) {
      console.error(err);
      setError(err.message || "Неуспешно бришење на кампањата.");
    }
  };

  return (
    <Card className="admin-card">
      <CardContent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          mb={2}
        >
          <Typography variant="h6">Sponsored Campaigns</Typography>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" size="small" onClick={loadCampaigns} disabled={loading}>
              Refresh
            </Button>
            <Button
              variant="contained"
              size="small"
              component={RouterLink}
              to="/dashboard/sponsored-campaigns/new"
            >
              New Campaign
            </Button>
          </Stack>
        </Stack>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
        {success ? <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert> : null}

        {loading ? (
          <Typography color="text.secondary">Loading campaigns...</Typography>
        ) : (
          <Box className="admin-table-wrap">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Placements</TableCell>
                  <TableCell>Priority</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {campaigns.map((campaign, index) => (
                  <TableRow key={campaign.id || index}>
                    <TableCell>{campaign.id || "-"}</TableCell>
                    <TableCell>{campaign.title || "-"}</TableCell>
                    <TableCell>
                      {Array.isArray(campaign.placements)
                        ? campaign.placements.join(", ")
                        : campaign.placements || "-"}
                    </TableCell>
                    <TableCell>{campaign.priority ?? "-"}</TableCell>
                    <TableCell>{campaign.isActive ? "Yes" : "No"}</TableCell>
                    <TableCell align="right">
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        justifyContent="flex-end"
                      >
                        <Button
                          size="small"
                          variant="outlined"
                          component={RouterLink}
                          to={`/dashboard/sponsored-campaigns/${campaign.id}/edit`}
                        >
                          Edit
                        </Button>
                        <Button
                          size="small"
                          color="error"
                          variant="text"
                          onClick={() => onDelete(campaign.id)}
                        >
                          Delete
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
                {campaigns.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      Нема достапни кампањи.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default AdminSponsoredCampaignsSection;
